export default "__VITE_ASSET___vAW8K7i__"